// supportSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase.config";

// Async Thunks
export const fetchSupportTickets = createAsyncThunk(
  "support/fetchSupportTickets",
  async (status, thunkAPI) => {
    try {
      const listTicketsFunction = httpsCallable(functions, "supportF-listTickets");
      const result = await listTicketsFunction(status ? { status } : {});
      return result.data.tickets;
    } catch (err) {
      console.error("Error fetching support tickets: ", err);
      return thunkAPI.rejectWithValue(
        "Failed to fetch support tickets. Please try again."
      );
    }
  }
);

export const setTicketStatus = createAsyncThunk(
  "support/setTicketStatus",
  async ({ ticketId, status }, thunkAPI) => {
    try {
      const updateTicketStatusFunction = httpsCallable(
        functions,
        "supportF-updateTicketStatus"
      );
      const result = await updateTicketStatusFunction({ ticketId, status });
      if (result.data.success) {
        return { ticketId, status };
      }
      return thunkAPI.rejectWithValue(
        "Failed to update ticket status. Please try again."
      );
    } catch (err) {
      console.error("Error updating ticket status: ", err);
      return thunkAPI.rejectWithValue(
        "Failed to update ticket status. Please try again."
      );
    }
  }
);

const supportSlice = createSlice({
  name: "support",
  initialState: {
    tickets: [],
    status: "idle", // idle | loading | succeeded | failed
    error: null,
    fetched: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSupportTickets.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchSupportTickets.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.tickets = action.payload || [];
        state.fetched = true;
        state.error = null;
      })
      .addCase(fetchSupportTickets.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        // Mark fetched even on failure: the dashboard effect guards on
        // !fetched, so leaving it false would re-dispatch in a tight loop
        // (loading -> failed -> effect refires) for as long as the tab is
        // open. Recovery is the explicit Refresh button.
        state.fetched = true;
      })
      .addCase(setTicketStatus.fulfilled, (state, action) => {
        const { ticketId, status } = action.payload;
        const ticket = state.tickets.find((t) => t.id === ticketId);
        if (ticket) {
          ticket.status = status;
        }
        state.error = null;
      })
      .addCase(setTicketStatus.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const selectSupportTickets = (state) => state.support.tickets;
export const selectSupportStatus = (state) => state.support.status;
export const selectSupportError = (state) => state.support.error;
export const selectSupportFetched = (state) => state.support.fetched;

export default supportSlice.reducer;
